import { DOCUMENT_TYPES } from 'constants/global';
import { Config } from 'containers/AppContainer/typings';
import { CorporealDocument } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { get, isEmpty } from 'lodash';
import { CONTESTATION_NATURE } from 'containers/LawyerLegalProceedingsPage/Contestation/constants';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
export const getDecisionDocuments = (
  constetationDocuments: CorporealDocument[] = [],
  judgementOnMeritsContestationNature: Config[] = [],
) => {
  let decisionDocuments: any = [];
  judgementOnMeritsContestationNature.forEach((contestationNature: Config) => {
    const decisionDocumentsFound =
      constetationDocuments.find((document: CorporealDocument) => {
        return (
          document.type ===
          `${DOCUMENT_TYPES.CONTESTATION} ${contestationNature.title}`
        );
      }) || {};
    !isEmpty(decisionDocumentsFound) &&
      decisionDocuments.push(decisionDocumentsFound);
  });
  return decisionDocuments || [];
};

export const getContestationDocuments = (
  contestationDocuments: CorporealDocument[],
) => {
  return contestationDocuments.filter(
    ({ type, isDeleted }: any) =>
      (type === DOCUMENT_TYPES.CONTESTATION_REQUEST ||
        type === DOCUMENT_TYPES.CONTESTATION_ACT) &&
      !isDeleted,
  );
};
export const findContestationNatureTitle = (
  judgementOnMeritsContestationNature: Config[],
  contestationNatureTitle: any,
) => {
  const contestationNature = judgementOnMeritsContestationNature.find(
    ({ id }: any) => id === contestationNatureTitle,
  );
  return get(contestationNature, 'title', null);
};
export const getContestationDecision = (decisionDocs: any) => {
  let decisions = {};
  get(decisionDocs, 'dec', []).forEach((item: any) => {
    const currentElement = {
      [item.victimId]: { victimId: item.victimId, amount: item.amount },
    };

    decisions = { ...decisions, ...currentElement };
  });
  return decisions;
};
export const hasAmountDecision = (
  decisionType: number,
  judgementOnMeritsContestationNature: Config[],
) => {
  return !isEmpty(
    judgementOnMeritsContestationNature.find(
      ({ id, title }) =>
        decisionType === id &&
        (title === CONTESTATION_NATURE.INCREASE ||
          title === CONTESTATION_NATURE.DISCOUNT),
    ) || {},
  );
};
export const isDisabled = (
  isLawyer: boolean = false,
  judgementOnMerits: any,
) => {
  return (
    (!isLawyer && get(judgementOnMerits, 'status') !== STATUS_REJECTED) ||
    !userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)
  );
};
